import { mapGetters, mapState } from 'vuex'
import { centsInSpan } from '../../../utils/euros'

export default {
  data() {
    return {
      priceHasFootNote: false,
    }
  },

  mounted() {
    if (this.canGetPrices) {
      this.checkPricesAndAvailability()
    }
  },
  watch: {
    bookingData: {
      deep: true,
      handler() {
        if (this.canGetPrices) {
          this.checkPricesAndAvailability()
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      formIsComplete: 'stepping/formIsComplete',
      canGetPrices: 'vehicles/canGetPrices',
      vehicleCardsProfileRequested: 'user/isGetProfileRequested',
      vehicleCardsUserIsLogged: 'auth/userIsLogged',
      vehicleCardsSelectedVehicleIsAvailable: 'vehicles/selectedVehicleIsAvailable',
      vehicleCardsSelectedVehiclePricePerday: 'vehicles/pricePerDay',
      vehicleCardsSelectedVehicleOnlinePrice: 'vehicles/onlinePrice',
      vehicleCardsSelectedVehicleOfflinePrice: 'vehicles/offlinePrice',

    }),
    ...mapState({
      bookingData: (state) => state?.booking?.drop,
      pickUpBusiness: (state) => state.booking?.pickUp?.business,
      storeVehicle: (state) => state?.vehicles?.set?.storeVehicle,
      numberOfVehicles: (state) => state?.vehicles?.availability?.allAvailabilities[this.vehicle.semi_clair],
      attemptingNavigation: (state) => state?.stepping?.attemptingNavigation,
      isDetailPage: (state) => state?.layout === 'vehicle-details-layout',
      vehicleCardsDepartureAgency: (state) => state?.booking?.pickUp?.business?.id,
      vehicleCardsReturnAgency: (state) => state?.booking?.drop?.business?.id,
    }),
    vehiclePrice() {
      return this.$store.state.vehicles.prices.allPrices[[this.vehicle.semi_clair]]
    },
    usePayment() {
      /* eslint-disable-next-line camelcase */
      return this.pickUpBusiness?.use_payment
    },
    markAsSelected() {
      if (!this.storeVehicle) {
        return false
      }
      if (this.storeVehicle.id === this.vehicle.id) {
        return true
      }
    },
    priceTxt() {
      const footNote = this.priceHasFootNote ? '*' : '';

      if (this.vehiclePrice) {
        return `${this.vehiclePrice.total_ttc.message}${footNote}`
      }
      return `${this.$t('pages.vehicles.starting_from')} 
      <span>${this.vehicle.rrs_category.formattedStartingPrice}</span>€${footNote}`
    },
    agencyPrice() {
      if (!this.pricePerDay) {
        return ''
      }
      return `${this.$t('pages.vehicles.agency_price')} ${this.vehiclePrice.total_no_discount.message}`
    },
    promoEnabled() {
      if (!this.vehicle.promotion) return false;

      const now = new Date();
      const dateStart = this.vehicle.promotion.date_start;
      const dateEnd = this.vehicle.promotion.date_end;

      if (now.toISOString() >= dateStart && now.toISOString() <= dateEnd) return true;
      return false;
    },
    pricePerDay() {
      if (!this.vehiclePrice || Number.isNaN(this.vehiclePrice.total_ttc.value)) {
        return false
      }
      const price = this.vehiclePrice.total_ttc.value;
      const days = this.vehiclePrice.nb_days.value;
      return `${this.$tc('pages.vehicles.per_day', days)} (${centsInSpan(Math.round((price / days) * 100) / 100)}€/Jour)`
    },
    vehicleLink() {
      return `/vehicules/${this.vehicle.slug}`
    },
    imageSrc() {
      return this.vehicle.images.high
    },
    plan() {
      const getPlan = this.$store.getters['vehicles/getPlan']
      return getPlan(this.vehicle.semi_clair)
    },
  },
  methods: {
    checkPricesAndAvailability() {
      this.$store.dispatch('vehicles/GET_AND_SET_AVAILABILITY')
      this.$store.dispatch('vehicles/GET_PRICES')
    },
    selectVehicle() {
      this.$store.commit('vehicles/SET_SELECTED_VEHICLE', this.vehicle)
      this.analytics()
      if (this.formIsComplete) {
        return this.$store.dispatch('stepping/VALIDATE_STEP_1');
      }
      if (this.isDetailPage && this.formIsComplete) {
        return this.$store.commit('stepping/TRIGGER_STEP_NAVIGATION', { step: 1 })
      }
      if (this.isDetailPage && !this.formIsComplete) {
        return this.$store.commit('stepping/TRIGGER_STEP_NAVIGATION', {
          step: 0,
        })
      }

      if (this.scrollToForm) {
        this.scrollToForm()
      }
    },
    analytics() {
      if (!window.dataLayer) {
        return
      }
      const event = 'addToCart'
      const departureAgency = this.vehicleCardsDepartureAgency
      const loginStatus = this.vehicleCardsProfileRequested ? this.vehicleCardsUserIsLogged : 'N/A'
      const page = window.location.href
      const pageTitle = document.querySelector('head title')?.text
      const returnAgency = this.vehicleCardsReturnAgency || this.vehicleCardsDepartureAgency
      const products = [{
        availabilityStatus: !!this.vehicleCardsSelectedVehicleIsAvailable,
        id: this.storeVehicle.id,
        vehicleModel: this.storeVehicle.semi_clair,
        price: this.vehicleCardsSelectedVehiclePricePerday,
        priceOnline: this.vehicleCardsSelectedVehicleOnlinePrice,
        priceAgency: this.vehicleCardsSelectedVehicleOfflinePrice,
      }]

      const payload = {
        event,
        page,
        departureAgency,
        loginStatus,
        pageTitle,
        returnAgency,
        products,
      }

      window.dataLayer.push(payload)
    },
  },
}
